<template>
    <v-btn :text="text"
           v-bind="$attrs"
           v-on="$listeners"
           type="button"
           :class="`btn btn-` + color"
    >
        <slot />
        <template #loader>
            <slot name="loader" />
        </template>
    </v-btn>

</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        color: {
            type: String,
            default: 'secondary'
        },
        text: Boolean
    }
}
</script>

<style>
/*noinspection CssUnusedSymbol*/
.v-btn.button-red-on-hover {
    /*transition: background-color 50ms ease;*/
    /* box-shadow,transform,opacity inherited from vuetify's v-button */
    transition-property: box-shadow, transform, opacity, background-color, color;
}

.v-btn.button-red-on-hover:hover {
    background-color: var(--color-error-background) !important;
    color: white !important;
}

</style>
